const DashboardPage = () => {
  return <div>dashboard AppPage</div>;
};

export default DashboardPage;
